import React from 'react'
import { useApiListNodeUser } from '../../../../../../api-new/state/content'
import { Menu, MenuAdd, MenuRemove } from '../../../../../../shared/menu/menu'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconUser } from '../../../../../../shared/icon/icon'
import { ModalDialog, useModalActionID } from '../../../../../../shared/component/modal-dialog'
import { PermissionNodeUserModal } from '../../../../../../shared/permission-modal/permission-node-user-modal'
import { useRoleOrgNodeUser } from '../../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'
import { ButtonPrimary } from '../../../../../../shared/component/button'
import { ButtonSecondary } from '../../../../../../shared/legacy/button'
import { useLoginSysAdmin } from '../../../../../../role/hook/login-sys-admin'

export const PermissionNodeUser = ({ nodeID }) => {
  const apiListNodeUser = useApiListNodeUser()

  const roleOrgNodeUser = useRoleOrgNodeUser()
  const loginSysAdmin = useLoginSysAdmin()

  const [target, show, hide] = useModalActionID()
  const [targetConfirm, showConfirm, hideConfirm] = useModalActionID()

  const handleReady = () => apiListNodeUser.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListNodeUser.init()

  const handleAddShow = () => show()
  const handleClose = () => hide()

  const handleClosed = async () => apiListNodeUser.get(`${nodeID}/node`)

  const handleDelete = async item => {
    await apiListNodeUser.delete(`${item.nodeID}/${item.userID}`)
    await apiListNodeUser.get(`${nodeID}/node`)
  }

  // const handleDeleteAll = async () => {
  //   await apiListNodeUser.delete(`node/${nodeID}`)
  //   await apiListNodeUser.get(`${nodeID}/node`)
  // }

  const handleDeleteDescendents = async () => showConfirm()
  const handleDeleteCancel = () => hideConfirm()

  const handleDeleteConfirm = async () => {
    await apiListNodeUser.delete(`node-descendents/${nodeID}`)
    await apiListNodeUser.get(`${nodeID}/node`)
    hideConfirm()
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" onClick={handleAddShow} show={roleOrgNodeUser.accessCreate} />
      {/* <MenuRemove text="remove all" onClick={handleDeleteAll} show={roleOrgNodeUser.accessDelete} /> */}
      <MenuRemove text="Remove All Cascade" onClick={handleDeleteDescendents} show={loginSysAdmin} />
    </Menu>

  return (
    <React.Fragment>
      <ModalDialog target={targetConfirm} header="Confirm">
        <div className="p-1">Are you sure?</div>
        <div>
          <ButtonPrimary onClick={handleDeleteConfirm} text="confirm" />
          <ButtonSecondary onClick={handleDeleteCancel} text="cancel" />
        </div>
      </ModalDialog>

      <PermissionNodeUserModal
        target={target}
        nodeID={nodeID}
        allowAdd={roleOrgNodeUser.accessCreate}
        allowDelete={roleOrgNodeUser.accessDelete}
        onClose={handleClose}
        onClosed={handleClosed}
      />
      <BreadcrumbView Icon={IconUser} text="User permissions">
        <CardFullHeightScrollY title="User permissions" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListNodeUser} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="email" header="Email" />
            <ColumnText field="firstName" header="First Name" />
            <ColumnText field="lastName" header="Last Name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRemove onClick={() => handleDelete(row)} show={roleOrgNodeUser.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
